export const SIMPLE_FRAME = 'frame_simple';
export const CIRCULAR_FRAME = 'frame_circular';
export const MAX_IMAGE_SIZE = 5120;
